import { FC } from "react";

import classes from "./Topic.module.css";
import { useNavigate } from "react-router-dom";
import { getLang, i18n } from "../../i18n";

interface Props {
  topicID: string;
  title: string;
  question: string;
  sponsor: string;
  andTags: string[];
  orTags: string[];
  createdAt: Date;
  updatedAt: Date;
  battlesCount: number;
  artworksCount: number;
}

const ArchivedTopic: FC<Props> = ({
  topicID,
  title,
  question,
  sponsor,
  andTags,
  orTags,
  createdAt,
  updatedAt,
  battlesCount,
  artworksCount,
}) => {
  const lang = getLang();
  const t = i18n.topic[lang];
  const navigate = useNavigate();
  return (
    <div
      className={`${classes.topic} ${classes.flex}`}
      onClick={() => {
        navigate(`/quiz?quiz=${topicID}`);
      }}
    >
      <div className={classes.left}>
        <h2>{title}</h2>
        <span className={classes.sponsor}>
          {t.by} {sponsor ? sponsor : t.rater}
        </span>
        <span className={classes.question}>{question}</span>

        {(andTags.length > 0 || orTags.length > 0) && (
          <div className={classes.tags}>
            {andTags.map((tag) => (
              <div
                key={`tag-${tag}`}
                className={`${classes.tag} ${classes.important}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 15"
                  fill="none"
                >
                  <path
                    d="M3.14697 8.20187L5.80826 10.5882L12.8529 4.41177"
                    stroke="#868686"
                    strokeWidth="1.11111"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {tag}
              </div>
            ))}
            {orTags.map((tag) => (
              <div key={`tag-${tag}`} className={classes.tag}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 15"
                  fill="none"
                >
                  <path
                    d="M3.14697 8.20187L5.80826 10.5882L12.8529 4.41177"
                    stroke="#868686"
                    strokeWidth="1.11111"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {tag}
              </div>
            ))}
          </div>
        )}

        <div className={classes.stats}>
          <span>
            ⚔️ {t.battles}: <span>{battlesCount}</span>
          </span>
          <span>
            🎨 {t.artworks}: <span>{artworksCount}</span>
          </span>
        </div>
      </div>
      <div className={classes.right}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 3 10 12 6 21"></polyline>
        </svg>
      </div>
    </div>
  );
};

export default ArchivedTopic;
